import React, { useEffect, useState } from 'react'
import CMS from '../../components/cms/CMS'
import PageBanner from '../../components/general/PageBanner'
import { useTranslation } from 'react-i18next'
import CMSTable from '../../components/general/CMSTable'
import { columns } from '../../utilities/columns/seoColumns'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSeoGetAll } from '../../redux/slices/seoGetAllSlice'
import { fetchSeoDelete } from '../../redux/slices/seoDeleteSlice'
import CrudSeo from './CrudSeo'

const SeoPage = () => {
    const { t } = useTranslation()
    const [modal, setModal] = useState(false)
    const [selectedItem, setSelectedItem] = useState(0)
    const [changed, setChanged] = useState(false)
    const lang = useSelector((state) => state.lang.lang)
    const seos = useSelector((state) => state.seoGetAll.data)
    const navigation = useNavigate()
    const dispatch = useDispatch()

    const getData = async () => {
        await dispatch(fetchSeoGetAll())
    }

    const deleteData = async (id) => {
        await dispatch(fetchSeoDelete({ id: id }))
        setChanged(true)
        getData()
    }

    useEffect(() => { getData() }, [dispatch, changed])

    return (
        <CMS>
            <PageBanner
                title={t("seo_management")}
                description={t("seo_management_desc")}
                buttonText={t("add_seo")}
                modal={modal}
                setModal={setModal}
            />

            <CMSTable
                columns={columns({
                    t: t,
                    modal: modal,
                    setModal: setModal,
                    lang: lang,
                    deleteData: deleteData,
                    navigation: navigation,
                    setSelectedItem: setSelectedItem
                })}
                data={seos}
            />

            <CrudSeo
                showMenu={modal}
                setShowMenu={setModal}
                setChanged={setChanged}
                setSelectedItem={setSelectedItem}
                selectedItem={selectedItem}
                t={t}
            />
        </CMS>
    )
}

export default SeoPage
